import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HtmlAudioComponent } from './../../../shared/components/html-audio/html-audio.component';
@Component({
  selector: 'app-html-audio-player-example',
  templateUrl: './html-audio-player-example.component.html',  
  styleUrls: ['./html-audio-player-example.component.css']
})
export class HtmlAudioPlayerExampleComponent implements OnInit {

  public _LastEvent = '';
  constructor() { }

  ngOnInit() {
  }

  Registered($event) {
    this._LastEvent = 'something happened';
  }

  AudioEvents(eventInfo: any) {
    this._LastEvent = eventInfo.eventName;
  }
}
